import { Pipe, PipeTransform } from '@angular/core';
import {Constants} from '../constants';

@Pipe({
  name: 'logicalOperator'
})
export class LogicalOperatorPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (!value) {
      return null;
    }
    if (value !== Constants.LOGICAL_OR && value !== Constants.LOGICAL_AND) {
      return value;
    }

    return value  === Constants.LOGICAL_AND ? Constants.AND : Constants.OR;
  }

}



// WEBPACK FOOTER //
// ./src/app/rules/pipes/logical-operator.pipe.ts